// Module-level cache for ActivityPlanner data so the page survives
// navigations (e.g. Home → Planner → Home → Planner renders instantly
// within TTL). Kept in its own module so mutations elsewhere in the app
// can invalidate without importing the heavy ActivityPlanner page.

const plannerCache = new Map(); // userId -> { data, ts }
const PLANNER_TTL_MS = 60_000;

export const getPlannerCached = (userId) => {
  if (!userId) return null;
  const entry = plannerCache.get(userId);
  if (!entry) return null;
  if (Date.now() - entry.ts > PLANNER_TTL_MS) {
    plannerCache.delete(userId);
    return null;
  }
  return entry.data;
};

export const setPlannerCached = (userId, data) => {
  if (!userId) return;
  plannerCache.set(userId, { data, ts: Date.now() });
};

// Bumped by every invalidation. A load that started before a mutation reads
// a different generation when it lands, so it knows what it fetched is older
// than what's on screen (usePlannerData's first load).
let generation = 0;
export const getPlannerGeneration = () => generation;

export const invalidatePlannerCache = (userId) => {
  generation += 1;
  if (userId) plannerCache.delete(userId);
  else plannerCache.clear();
};
